import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import {
  RdsBadgeComponent,
  RdsButtonComponent,
  RdsCustomIconComponent,
  RdsEmptyStateComponent,
  RdsEmptyStateImageComponent,
  RdsEmptyStateTitleDirective,
  RdsIconComponent,
} from '@rds/angular-components';

import { EventDateTimePipe } from '@bookly/shared';

import { BookingWithConvertedServices } from '../../services/booking.service';

@Component({
  selector: 'bus-booking-list',
  imports: [
    ScrollingModule,
    NgOptimizedImage,
    RdsIconComponent,
    RouterLink,
    RdsBadgeComponent,
    EventDateTimePipe,
    RdsEmptyStateComponent,
    RdsEmptyStateImageComponent,
    RdsEmptyStateTitleDirective,
    RdsCustomIconComponent,
    RdsButtonComponent,
  ],
  templateUrl: './booking-list.component.html',
  styleUrl: './booking-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingListComponent {
  @Input() public bookings!: BookingWithConvertedServices[];
}
